// extracted by mini-css-extract-plugin
export default {"key":"button-key_key__L1RZL"};